module.exports = __webpack_public_path__ + "img/upload-img.8dd214d8.svg";